import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DateState = {
  totalFormat: Record<string, string>;
  format: string;
};

const initialState: DateState = {
  totalFormat: {
    slash: 'DD/MM/YYYY',
    dash: 'DD-MM-YYYY',
    long: 'D MMMM YYYY',
  },
  format: 'DD/MM/YYYY',
};

const dateFormatterSlice = createSlice({
  name: 'dateFormatter',
  initialState,
  reducers: {
    setDateFormat(state, action: PayloadAction<string>) {
      state.format = state.totalFormat[action.payload] || state.format;
    },
  },
});

export const { setDateFormat } = dateFormatterSlice.actions;
export default dateFormatterSlice.reducer;
